import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Homepage from "./site/Homepage";
import AdmApp from "./adm/AdmApp";
import Login from "./adm/Login";
import Logout from './adm/Logout';
import AboutProject from "./site/AboutProject";
import Copyright from "./site/Copyright";
import Artists from "./site/Artists";
import ArtisticMovementsAndPhenomena from "./site/ArtisticMovementsAndPhenomena";
import SearchTerms from "./site/SearchTerms";
import PhotoDocumentation from "./site/PhotoDocumentation";
import PhotoSer from "./site/PhotoSer";
import Aboutartisttext from "./site/AboutArtistText";
import GUnitList from "./site/GUnitList";
import DocumentViewPdf from "./site/DocumentView";

import "../index.scss";
import DlUnitLi from "./adm/DlUnitLi";

function App() {
  return (
    <Router>
      <div className="home-page">
        <div className="App">
          <Switch>
            <Route path="/" exact component={Homepage} />
            <Route path="/admin-dashboard" component={AdmApp} />
            <Route AboutProject exact path="/about" component={AboutProject} />
            <Route Copyright path="/copyright" component={Copyright} />
            <Route Artists path="/artists" component={Artists} />
            <Route
              ArtisticMovementsAndPhenomena
              path="/art-movements-and-phenomena"
              component={ArtisticMovementsAndPhenomena}
            />
            <Route SearchTerms path="/search-terms" component={DlUnitLi} />
            <Route
              PhotoSer
              path="/g/:groupSlug/photo-series/:serType/:serSlug"
              component={PhotoSer}
            />
            <Route
              PhotoDocumentation
              path="/g/:groupSlug/photo-series/:serType"
              component={PhotoDocumentation}
            />
            <Route
              Aboutartisttext
              path="/about-artist-text"
              component={Aboutartisttext}
            />
            <Route
              Aboutartisttext
              path="/g/:groupSlug"
              component={Aboutartisttext}
              exact
            />
            <Route
              GUnitList
              path="/g/:groupSlug/:uType"
              component={GUnitList}
              exact
            />
            <Route GUnitList path="/hemeroteka" component={GUnitList} exact />
            <Route GUnitList path="/u/:idSlug" component={DocumentViewPdf} />
            <Route
              DocumentViewPdf
              path="/document-view"
              component={DocumentViewPdf}
            />
            <Route path="/l-in" component={Login} />
            <Route path="/l-out" component={Logout} />

          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
